import styled from "@emotion/styled";
import { CustomThemeType } from "../../context/Providers";

export const DateRangePickerWrapper = styled.div<{ theme?: CustomThemeType }>`
  & .rdrDefinedRangesWrapper {
    display: none;
  }

  & .rdrCalendarWrapper {
    background-color: ${({ theme }) => theme?.background};
    border: 2px solid ${({ theme }) => theme?.dividerColor};
    border-radius: 12px;
    overflow: hidden;
  }

  & .rdrDateDisplayWrapper {
    display: none;
  }

  & .rdrMonthName,
  & .rdrWeekDay {
    color: ${({ theme }) => theme?.brand};
  }

  & .rdrDay {
    background-color: ${({ theme }) => theme?.mainBackground};
    color: ${({ theme }) => theme?.foreground};
  }

  & .rdrDayDisabled {
    opacity: 0.4;
  }

  & .rdrDayNumber span {
    color: ${({ theme }) => theme?.foreground};
  }

  & .rdrDayNumber span::after {
    background: ${({ theme }) => theme?.brand};
    opacity: 0.25;
  }

  & .rdrDayToday .rdrDayNumber span::after {
    border-color: ${({ theme }) => theme?.accent};
  }

  & .rdrStartEdge,
  & .rdrEndEdge,
  & .rdrSelected {
    box-shadow: none;
  }

  & .rdrDay.rdrInRange,
  & .rdrDay.rdrStartEdge,
  & .rdrDay.rdrEndEdge,
  & .rdrDay.rdrSelected {
    background-color: ${({ theme }) => theme?.brand};
  }

  & .rdrDay.rdrInRange .rdrDayNumber span,
  & .rdrDay.rdrStartEdge .rdrDayNumber span,
  & .rdrDay.rdrEndEdge .rdrDayNumber span,
  & .rdrDay.rdrSelected .rdrDayNumber span {
    color: ${({ theme }) => theme?.brandContrast ?? theme?.background};
  }

  & .rdrInRange,
  & .rdrStartEdge,
  & .rdrEndEdge,
  & .rdrSelected {
    color: ${({ theme }) => theme?.brandContrast ?? theme?.background} !important;
  }

  & .rdrNextPrevButton,
  & .rdrNextPrevButton i {
    color: ${({ theme }) => theme?.foreground};
    background-color: ${({ theme }) => theme?.mainBackground};
  }

  & .rdrMonthAndYearPickers select {
    color: ${({ theme }) => theme?.brand};
    background-color: ${({ theme }) => theme?.mainBackground};
  }
`;

export default DateRangePickerWrapper;
